// src/components/BodyWrapper.js
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function BodyWrapper({ children, className = "", loading }) {
  const [state, setState] = useState({
    active: "Home",
  });
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.replace("/", "");
    if (!path) {
      setState((prev) => ({ ...prev, active: "Home" }));
    } else {
      setState((prev) => ({ ...prev, active: path || "" }));
    }
  }, [location.pathname]);
  return (
    <div
      className={`w-full pb-2 ${loading ? "blur-md" : ""} ${
        state.active === "Home"
          ? "pt-[178px] md:pt-[182px] xl:pt-64 xl:pb-10 lg:pb-10 md:pb-4 pb-2"
          : "pt-[184px] lg:pt-[194px] xl:pb-10 md:pb-4 pb-4"
      } ${className}`}
    >
      {children}
    </div>
  );
}
